import PageMarketingV2Menu from "./PageMarketingV2Menu";

function PageMarketingV2Gallery() {
    const image_urls = [
        'https://adtangs.fra1.digitaloceanspaces.com/3d44fde1-1cd4-40f6-beea-3c8580efb4f5.jpg',
        'https://adtangs.fra1.digitaloceanspaces.com/7bde78bf-9338-40d2-9adc-f231197cc898.jpg',
        "https://www.ukpos.com/media/catalog/product/cache/ee2181f58bae4ec835fcaf55a2688cc9/d/d/ddvr_1_1_1.png",
        "https://image.made-in-china.com/2f0j00GhWljmMCfNRf/Factory-32-49-55-65-Inch-Android-4K-Totem-Touch-Screen-Digital-Signage-Kiosk-LCD-Floor-Standing-Advertising-Display.jpg",
        'https://www.digitalframe0.com/wp-content/uploads/2021/06/wall-mounted-and-free-standing-digital-advertising-screen-and-poster-display-640x480.jpg',
        "https://static.commerceplatform.services/images/touchscreens.600.jpg",
        "https://amezeus.com/wp-content/uploads/2019/08/Ecran-Affichage-LCD-2.jpg",
        "https://image.made-in-china.com/2f0j00YVsGBtFPbzkO/LCD-WiFi-Advertising-Player-for-Advertising-Indoor-Shop-Window-OLED-Display-TV.jpg",
        "https://image.made-in-china.com/2f0j00kVfUJAtPrSbN/18-5-Inch-Capacitive-Touch-Screen-Large-Size-Android-6-0-Advertising-Tablet-PC-with-1366-768.webp",
        "https://sc04.alicdn.com/kf/H8a15555a2bb34ce3ad1dedf6cd735090X.jpg",
    ]

    const divImages = image_urls.map(
        img_src =>
            <img
                src={img_src}
                className='marketing-item2'
                style={{ cursor: 'pointer' }}
            />
    );
    return (
        <div>
            <PageMarketingV2Menu />
            <div
                style={{
                    paddingTop: '6em',
                    height: '100vh'
                }}
            >
                {divImages}
            </div>
        </div>
    );
}

export default PageMarketingV2Gallery;